<template>
    <div id="alert-box" :class="['popup',$root.alert[0]?($root.alert[0][0]?'':$root.alert[0].type):(last[0]?'':last.type)]">
        <div class="alert-body fixed-box s-content">
            <div class="content">
                <div :class="['img']"></div>
                <p v-html="$root.alert[0]?($root.alert[0][0]?$root.alert[0]:$root.alert[0].text):(last[0]?last:last.text)"></p>
            </div>
            <button class="close" @click="close"></button>
        </div>
    </div>
</template>
<style lang="less">
    #alert-box.helper .content .img {
        background-image: url("../assets/images/alert_tip.png");
        background-color: #1dda21;
        box-shadow: 5px 5px 10px rgba(63, 243, 41, 0.22);
    }

    #alert-box.success .content .img {
        background-image: url("../assets/images/alert_success.png");
        background-color: #1dda21;
        box-shadow: 5px 5px 10px rgba(63, 243, 41, 0.22);
    }

    #alert-box .alert-body {
        padding: 30px 60px 30px 40px;
        position: relative;
        max-width: calc(100% - 200px);
        max-height: calc(100% - 100px);
        border-top: 4px solid #4484f3;

        .img {
            background-color: #4484f3;
            width: 60px;
            height: 60px;
            border-radius: 50%;
            background-image: url("../assets/images/alert_tip.png");
            background-size: 60%;
            background-repeat: no-repeat;
            background-position: center;
            margin-right: 20px;
            box-shadow: 3px 3px 10px rgba(68, 132, 243, 0.27);
            flex-shrink: 0;
        }

        .close {
            right: 11px;
            top: 10px;
        }
    }

    #alert-box .content {
        display: flex;
        align-items: center;
        color: #5f5f5f;
        font-size: 16px;
    }

    #alert-box .content img {
        margin-right: 18px;
        flex-shrink: 0;
    }

    #alert-box .content p {
        margin: 0;
        word-break: break-word;
        overflow-y: auto;
        font-size: 18px;
        display: flex;
        align-self: stretch;
        align-items: center;
    }

    #alert-box .content p::-webkit-scrollbar {
        width: 0;
    }

    #alert-box .content p:hover::-webkit-scrollbar {
        width: 2px;
    }

    #alert-box .bts {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    #alert-box .bts button {
        width: 150px;
        height: 50px;
        background-color: white;
        font-size: 16px;
        border-radius: 1px;
        transition: all .2s;
    }

    #alert-box .bts button:hover {
        opacity: .7;
    }

    #alert-box .bts .yes {
        border: 1px solid #c4a66a;
        color: #c4a66a;
    }

    #alert-box .bts .no {
        border: 1px solid #b2b2b2;
        color: #b2b2b2;
    }

    #alert-box .close {
        width: 22px;
        height: 22px;
        background-image: url(../assets/images/alert_close.png);
        background-repeat: no-repeat;
        background-position: center;
        background-size: 22px;
        position: absolute;
        right: 32px;
        top: 22px;
        background-color: white;
        border: none;
        transition: all .2s;
    }

    #alert-box .close:hover {
        transform: scale(1.12);
    }
</style>
<script>
    // 只需要弹出文字提示则只用push字符串；需要点击确定后执行函数则push {text:"test",fn:function(){}}
    export default {
        data: function () {
            return {
                last: ""
            }
        },
        mounted(){
            
        },
        computed: {
            auto() {
                return this.$root.alertAuto
            }
        },
        methods: {
            close: function () {
                this.last = this.$root.alert.shift();
                if (typeof this.last == "object") {
                    this.last.fn && this.last.fn();
                }
            }
        },
        watch: {
            auto: {
                handler(newVal){
                    let that = this;
                    console.log(newVal)
                    if(newVal){
                        setTimeout(()=>{
                            that.close();
                            that.$root.alertAuto=false;
                        },1000);
                    }
                },
                immediate: true
            }
        }
    }
</script>